interface IProps {
  label: string;
  unit: string;
  error?: boolean;
  readOnly?: boolean;
  value?: string | number;
  onChange?: (e: string) => void;
  disabled?: boolean;
}

const StakeInput = ({
  value,
  onChange,
  label,
  readOnly,
  unit,
  error,
  disabled,
}: IProps) => {
  return (
    <div
      className={`font-inter bg-opacity-[0.04] focus-within:bg-opacity-[0.04] hover:bg-opacity-[0.12] text-white rounded-xl border px-4 flex flex-col gap-2 py-[14px] ${
        error
          ? "border-error bg-[#DE0B0B]"
          : "focus-within:border focus-within:border-white/50 bg-white border-transparent"
      } ${readOnly ? "cursor-default" : "cursor-pointer"}`}
    >
      <div className="text-sm leading-5 font-semibold">{label}</div>
      <div className="flex justify-between items-center">
        <input
          onWheel={(e) => (e.target as HTMLElement).blur()}
          value={value}
          onKeyDown={(e) =>
            ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
          }
          onChange={(e) => {
            if (!onChange) return;
            const value = e.target.value;
            if (/^[0-9.]*$/.test(value) && !isNaN(Number(value)))
              onChange(value);
          }}
          readOnly={readOnly}
          type="number"
          className={`text-[32px] bg-transparent outline-none focus:outline-none w-full [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${
            readOnly ? "cursor-default" : "cursor-auto"
          }`}
          disabled={disabled}
          placeholder="0"
        />
        <span className="font-bold text-2xl leading-10">{unit}</span>
      </div>
    </div>
  );
};

export default StakeInput;
